import React from 'react';
import styled from 'styled-components';
import { useI18n } from '@oneaudi/i18n-context';
import { messages } from '../../../i18n/messages';
import { ReactComponent as CloseIcon } from '../../../icons/cancel-small.svg';
import { ReactComponent as CautionIcon } from '../../../icons/caution-small.svg';
import mapContext from '../../../contexts/map-context';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';
import trackingContext from '../../../contexts/tracking-context';
import { trackUserLocationAction } from '../../../utils/trackingUtils';
import { TrackingEvents } from '../../../utils/trackingService';

export default function LocationErrorMessage() {
  const dispatch = mapContext.useMapDispatch();
  const { trackingService: tService } = trackingContext.useTrackingState();
  const { isUserLocationPermissionGiven } = mapContext.useMapState();

  React.useEffect(() => {
    if (isUserLocationPermissionGiven) {
      trackUserLocationAction(tService, TrackingEvents.LOCATION_NOT_RETRIEVED_PERMISSION_GIVEN);
    }
  }, []);

  return (
    <LocationErrorMessageContainer data-test-id="location-error-container">
      <CautionIconContainer data-test-id="caution-icon-container">
        <CautionIcon />
      </CautionIconContainer>
      <ErrorMessageTextContainer data-test-id="error-message-text-container">
        <ErrorMessageTitle>{useI18n(messages.error_message_header)}</ErrorMessageTitle>
        <p>{useI18n(messages.error_message_body)}</p>
      </ErrorMessageTextContainer>
      <CancelIconContainer
        onClick={() => dispatch({ type: ActionTypes.setShowLocationError, payload: false })}
        data-test-id="cancel-icon-container"
      >
        <CloseIcon />
      </CancelIconContainer>
    </LocationErrorMessageContainer>
  );
}

const LocationErrorMessageContainer = styled.div`
  background-color: #e5e5e5;
  max-width: 400px;
  margin-right: 10px;
  margin-top: 10px;
  position: absolute;
  right: 0;
  justify-content: space-between;
  flex-direction: row;
  display: flex;
  z-index: 1;
`;

const ErrorMessageTitle = styled.p`
  margin-bottom: 16px;
  font-weight: bold;
`;

const ErrorMessageTextContainer = styled.div`
  max-width: 300px;
  padding-top: 12px;
`;

const CautionIconContainer = styled.div`
  max-width: 50px;
  padding: 12px 13px;
  margin-top: 16px;
`;

const CancelIconContainer = styled.div`
  cursor: pointer;
  max-width: 50px;
  padding: 12px 13px;
  margin-top: 16px;
`;
